<!--suppress ALL -->
<script lang="ts">
import {wilayahPutris} from '../../../util/PluralVariabels';
import {Component, Vue, Prop} from 'annotation';
import {cloneArray} from "../../../util/Underscore";

import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';

@Component
export default class WilayahPutriSelect extends Vue {

  @Prop({default: wilayahPutris[0].value, type: String})
  public wilayah: string;

  @Prop({default: false, type: Boolean})
  public skipLabel: boolean;

  @Prop({default: true, type: Boolean})
  public isFullwidth: boolean;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  @Prop({type: Boolean, default: false})
  public disabled: any;

  public onSelectWilayah(param: any) {
    this.$emit('update:wilayah', param || wilayahPutris[0].value);
    this.$emit('wilayah-selected', param);
    this.$emit('input', param || wilayahPutris[0].value);
  }

  public render(createElement: Function) {
    const {$t, wilayah, isFullwidth, message, type} = this;

    const mainAttr: any = {
      props: {
        value: wilayah,
        isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.wilayah')}`
      },
      attrs: {disabled: this.disabled},
      on: {change: this.onSelectWilayah}
    };

    const main: any = createElement(GSelect, mainAttr, cloneArray(wilayahPutris).map((item: any) => {
      const option: any = {attrs: {value: item.value}};

      return createElement('option', option, item.label.toUpperCase());
    }));

    if (this.skipLabel) {
      return main;
    }

    const displayMessage = typeof message === 'object' && message !== null ? message.message : message;
    const displayType = typeof message === 'object' && message !== null ? message.type : type;

    return createElement(GField, {props: {label: $t('label.wilayah'), message: displayMessage, type: displayType}}, [main]);
  }
}
</script>
